<template>
  <div class="content c895">
    <h2>Računalnik 1</h2>
  </div>
  <div class="content c590">
    <div class="popup popDev10" style="display:none;">
      <div class="inner">
        <h3>Ali ste prepričani, da želite izbrisati napravo?</h3>
        <div class="msg">
          <h3>Računalnik</h3>
        </div>
        <div class="con">
          <p>Izbrišite napravo, če ste se zmotili pri njenih podatkih oziroma ste izbrali napačno napravo. Če bi želeli, jo lahko kasneje brez težav ponovno dodate.</p>
        </div>
        <div class="btns">
          <a
            href="javascript:void(0)"
            class="btn"
            title="Več"
            onclick="popupDelete(&quot;popDev10&quot;)"
          >NE, PREKLIČI</a>
          <a
            id="ctl00_ContentPlaceHolder1_lnkBtnDeleteDevice"
            class="btn"
            href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$lnkBtnDeleteDevice','')"
          >DA, IZBRIŠI</a>
        </div>
      </div>
    </div>
    <div class="appliance">
      <table>
        <tbody>
          <tr>
            <td class="first">Računalnik</td>
            <td>Namizni računalnik + 24-palčni lcd led zaslon</td>
            <td class="last">
              <div class="tools">
                <a
                  href="javascript:void(0)"
                  title="Zbriši"
                  class="close"
                  onclick="popupDelete(&quot;popDev10&quot;)"
                >Zbriši</a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="appliance data">
      <div class="icon">
        <span class="R">Računalnik</span>
      </div>
      <div class="first">
        <h5>TRENUTNA PORABA</h5>
        <span id="ctl00_ContentPlaceHolder1_lblConsumption">
          <span class="et">
            443 kWh / leto
            <div class="tooltip-bottom">
              Enotna tarifa (ET) je tarifa, ki jo beleži enotarifni števec vsak dan od 0.00 do 24.00 ure. Cena električne energije je ves čas enaka. V primeru, da imate enotarifno merjenje in želite dvotarifnega, pokličite v vaše elektrodistribucijsko podjetje za podrobnejše informacije.
              <br />
              <a
                href="http://www.uresnicujmo.si/o_aplikaciji_za_izracun_prihrankov/predstavitev#tarife"
                target="_blank"
                title="Več"
              >Več o tem &gt;</a>
            </div>
          </span>
        </span>
        <em>
          <span id="ctl00_ContentPlaceHolder1_lblTotalPrice">33,46 € / leto</span>
        </em>
      </div>

      <div class="no-data">
        <h5>VAŠI PRIHRANKI</h5>
        <h5>VAŠA NOVA PORABA</h5>
        <div class="message">
          <p>Za izračun nove porabe in prihrankov na izbrani napravi izvedi vsaj en ukrep.</p>
        </div>
      </div>
    </div>
    <div class="actions">
      <div class="toggle-btn" style="display:none;">
        <a href="javascript:void(0)" class="active">Prihranki zaradi izvedenih ukrepov</a>
      </div>
      <ul class="actionsExistingUl"></ul>

      <h3>Zmanjšajte porabo naprave Računalnik 1</h3>
      <p>Zmanjšajte porabo tako, da izvedete vsaj enega, še bolje pa več, spodaj navedenih ukrepov. Izberite le tiste, ki so v vaših razmerah pomembni.</p>
      <ul>
        <li id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_divAction">
          <a
            class="actionBtnMore active"
            style="cursor:pointer;"
          >Zamenjamo računalnik z energijsko varčnejšim</a>

          <div style class="actionPnlMore">
            <div id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_Panel5">
              <div class="form">
                <h3>Izberite lastnosti novega Računalnika:</h3>
                <fieldset>
                  <div class="f-item select">
                    <label>
                      Tip računalnika:
                      <span>(in zaslona)</span>
                    </label>
                    <span
                      id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_RequiredFieldValidator8"
                      style="color:Red;float:none;font-size:1em;visibility:hidden;"
                    >*</span>
                    <select
                      name="ctl00$ContentPlaceHolder1$RepeaterActions$ctl00$ddlClassComputer"
                      id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_ddlClassComputer"
                    >
                      <option value="0">Izberite</option>
                      <option value="109">Prenosni računalnik 12 do 14-palčni zaslon</option>
                      <option value="110">Prenosni računalnik 15 do 17-palčni zaslon</option>
                      <option value="111">Namizni računalnik + 17-palčni lcd zaslon</option>
                    </select>
                    <!-- tooltip + div added-->
                    <div class="help">
                      <a href="#" class="help" title="Help">Help</a>
                      <div
                        class="tooltip"
                      >V mnogih gospodinjstvih (in tudi pisarnah) je skupina porabnikov električne energije, ki jo sestavljajo računalnik + monitor + tiskalnik + modem + DSL usmerjevalnik, ena izmed največjih porabnikov električne energije. Zato lahko že z nekaj preprostimi vsakodnevnimi ukrepi precej privarčujemo.</div>
                    </div>
                    <!-- //end -->
                  </div>
                </fieldset>
              </div>
            </div>

            <div class="advice">
              <div class="right">
                <a
                  id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_lnkBtnAdd"
                  class="btn"
                  href="javascript:WebForm_DoPostBackWithOptions(new WebForm_PostBackOptions(&quot;ctl00$ContentPlaceHolder1$RepeaterActions$ctl00$lnkBtnAdd&quot;, &quot;&quot;, true, &quot;ChangeDevice&quot;, &quot;&quot;, false, true))"
                >Izvedi ukrep</a>
              </div>
              <p>
                Monitorji LCD porabijo med
                <b>50 in 70 %</b> manj energije kot monitorji s katodno cevjo (CRT); v primeru 8 delovnih ur delovanja dnevno so prihranki iz tega naslova več kot 100 kWh/leto. Prihranili ne bomo le električne energije, ampak tudi delovni prostor in zdravje (predvsem utripanje, paralaksa in geometrijske nepravilnosti).
                <br />
                <br />Ob zamenjavi računalnika se odločimo za prenosni računalnik, ki porabi v stanju delovanja okoli
                <b>30 % manj</b> energije kot namizni računalnik.
              </p>
            </div>
          </div>
        </li>

        <li id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl01_divAction">
          <a class="actionBtnMore" style="cursor:pointer;">Izklapljamo iz vtičnice</a>

          <div style="display:none;" class="actionPnlMore">
            <div class="advice">
              <div class="right">
                <a
                  id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl01_lnkBtnAdd"
                  class="btn"
                  href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$RepeaterActions$ctl01$lnkBtnAdd','')"
                >Izvedi ukrep</a>
              </div>
              <p>
                V povprečju kar
                <b>40 odstotkov naprav</b> še vedno porablja električno energijo tudi takrat, ko so izklopljene/v stanju pripravljenosti. Strokovnjaki ocenjujejo, da tako porabimo okoli
                <b>10 % energije</b> v gospodinjstvu. Z izklopom iz vtičnice bomo tako dosegli, da naprave ne bodo porabljale električnega toka, pomagale pa nam bodo zmanjšati račun za električno energijo. Če več naprav priklopimo na razdelilec, lahko z enim posegom izklopimo več naprav hkrati, s čimer je njihova poraba nič (=0).
              </p>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="advice">
      <h4>Imejte vedno v mislih, da lahko prihranite!</h4>
      <p>Na porabo vaše naprave vplivajo različni dejavniki, od energetskega razreda do načina, kako jo uporabljate. Preberite dodatne nasvete, kako znižati porabo električne energije v vašem gospodinjstvu.</p>
      <a
        href="http://www.uresnicujmo.si/nasveti/racunalnik"
        target="_blank"
        alt="več"
        class="more"
      >Preberite si več nasvetov</a>
    </div>
  </div>
  <div class="content r-c">
    <div class="c282">
      <h3>PORABA NAPRAVE RAČUNALNIK 1</h3>
      <div class="select">
        <select
          name="ctl00$ContentPlaceHolder1$ddlUsageType"
          onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageType\',\'\')', 0)"
          id="ctl00_ContentPlaceHolder1_ddlUsageType"
          class="s156"
        >
          <option selected="selected" value="1">Kumulativna poraba (€)</option>
          <option value="2">Kumulativna poraba (kWh)</option>
        </select>
        <select
          name="ctl00$ContentPlaceHolder1$ddlUsageTSpan"
          onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageTSpan\',\'\')', 0)"
          id="ctl00_ContentPlaceHolder1_ddlUsageTSpan"
        >
          <option selected="selected" value="1">za 1 leto</option>
          <option value="5">za 5 let</option>
          <option value="10">za 10 let</option>
          <option value="15">za 15 let</option>
        </select>
      </div>

      <div class="graph">
        <div class="chart">
          <div
            id="ctl00_ContentPlaceHolder1_divCurrentUsage"
            class="col without"
            style="height:100%;"
          >
            <span id="ctl00_ContentPlaceHolder1_lblCurrentUsage">33,46 €</span>
          </div>
        </div>
        <div class="legend">
          <div class="col">
            <strong>Poraba brez</strong> izvedenih ukrepov
          </div>
          <div class="col">
            <strong>Poraba z</strong> izvedenimi ukrepi
          </div>
        </div>
      </div>
    </div>
    <div class="c282">
      <h3>PORABA NAPRAVE RAČUNALNIK 1</h3>
      <div class="select">
        <select
          name="ctl00$ContentPlaceHolder1$ddlUsageType2"
          onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageType2\',\'\')', 0)"
          id="ctl00_ContentPlaceHolder1_ddlUsageType2"
          class="s156"
        >
          <option selected="selected" value="1">Kumulativna poraba (€)</option>
          <option value="2">Kumulativna poraba (kWh)</option>
        </select>
        <select
          name="ctl00$ContentPlaceHolder1$ddlUsageTSpan2"
          onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageTSpan2\',\'\')', 0)"
          id="ctl00_ContentPlaceHolder1_ddlUsageTSpan2"
        >
          <option value="1">za 1 leto</option>
          <option selected="selected" value="5">za 5 let</option>
          <option value="10">za 10 let</option>
          <option value="15">za 15 let</option>
        </select>
      </div>
      <div class="graph image">
        <div class="chart">
          <img
            id="ctl00_ContentPlaceHolder1_Chart1"
            src="/Images/Charts/Chart000006.png?d60ca4d7-ad80-40fa-85eb-795abfdae8b6"
            alt
            usemap="#ctl00_ContentPlaceHolder1_Chart1ImageMap"
            style="height:168px;width:263px;border-width:0px;padding:0;"
          />
          <map
            name="ctl00_ContentPlaceHolder1_Chart1ImageMap"
            id="ctl00_ContentPlaceHolder1_Chart1ImageMap"
          >
            <area
              shape="poly"
              coords="200, 144, 200, 47, 200, 47, 257, 19, 257, 19, 257, 144, 200, 144"
              title="13.11.2025; 167,28401144"
              alt
            />
            <area
              shape="poly"
              coords="144, 144, 144, 75, 144, 75, 200, 47, 200, 47, 200, 144, 144, 144"
              title="13.11.2024; 133,827209152"
              alt
            />
            <area
              shape="poly"
              coords="87, 144, 87, 104, 87, 104, 144, 75, 144, 75, 144, 144, 87, 144"
              title="13.11.2023; 100,370406864"
              alt
            />
            <area
              shape="poly"
              coords="30, 144, 30, 132, 30, 132, 87, 104, 87, 104, 87, 144, 30, 144"
              title="13.11.2022; 66,913604576"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 19, 257, 19, 30, 132, 30, 132, 30, 144, 257, 144"
              title="13.11.2021; 33,456802288"
              alt
            />
            <area
              shape="poly"
              coords="200, 144, 200, 47, 200, 47, 257, 19, 257, 19, 257, 144, 200, 144"
              title="13.11.2025; 167,28401144"
              alt
            />
            <area
              shape="poly"
              coords="144, 144, 144, 75, 144, 75, 200, 47, 200, 47, 200, 144, 144, 144"
              title="13.11.2024; 133,827209152"
              alt
            />
            <area
              shape="poly"
              coords="87, 144, 87, 104, 87, 104, 144, 75, 144, 75, 144, 144, 87, 144"
              title="13.11.2023; 100,370406864"
              alt
            />
            <area
              shape="poly"
              coords="30, 144, 30, 132, 30, 132, 87, 104, 87, 104, 87, 144, 30, 144"
              title="13.11.2022; 66,913604576"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 19, 257, 19, 30, 132, 30, 132, 30, 144, 257, 144"
              title="13.11.2021; 33,456802288"
              alt
            />
            <area
              shape="poly"
              coords="200, 144, 200, 47, 200, 47, 257, 19, 257, 19, 257, 144, 200, 144"
              title="13.11.2025; 167,28401144"
              alt
            />
            <area
              shape="poly"
              coords="144, 144, 144, 75, 144, 75, 200, 47, 200, 47, 200, 144, 144, 144"
              title="13.11.2024; 133,827209152"
              alt
            />
            <area
              shape="poly"
              coords="87, 144, 87, 104, 87, 104, 144, 75, 144, 75, 144, 144, 87, 144"
              title="13.11.2023; 100,370406864"
              alt
            />
            <area
              shape="poly"
              coords="30, 144, 30, 132, 30, 132, 87, 104, 87, 104, 87, 144, 30, 144"
              title="13.11.2022; 66,913604576"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 19, 257, 19, 30, 132, 30, 132, 30, 144, 257, 144"
              title="13.11.2021; 33,456802288"
              alt
            />
            <area
              shape="poly"
              coords="200, 144, 200, 47, 200, 47, 257, 19, 257, 19, 257, 144, 200, 144"
              title="13.11.2025; 167,28401144"
              alt
            />
            <area
              shape="poly"
              coords="144, 144, 144, 75, 144, 75, 200, 47, 200, 47, 200, 144, 144, 144"
              title="13.11.2024; 133,827209152"
              alt
            />
            <area
              shape="poly"
              coords="87, 144, 87, 104, 87, 104, 144, 75, 144, 75, 144, 144, 87, 144"
              title="13.11.2023; 100,370406864"
              alt
            />
            <area
              shape="poly"
              coords="30, 144, 30, 132, 30, 132, 87, 104, 87, 104, 87, 144, 30, 144"
              title="13.11.2022; 66,913604576"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 19, 257, 19, 30, 132, 30, 132, 30, 144, 257, 144"
              title="13.11.2021; 33,456802288"
              alt
            />
            <area
              shape="poly"
              coords="200, 144, 200, 47, 200, 47, 257, 19, 257, 19, 257, 144, 200, 144"
              title="13.11.2025; 167,28401144"
              alt
            />
            <area
              shape="poly"
              coords="144, 144, 144, 75, 144, 75, 200, 47, 200, 47, 200, 144, 144, 144"
              title="13.11.2024; 133,827209152"
              alt
            />
            <area
              shape="poly"
              coords="87, 144, 87, 104, 87, 104, 144, 75, 144, 75, 144, 144, 87, 144"
              title="13.11.2023; 100,370406864"
              alt
            />
            <area
              shape="poly"
              coords="30, 144, 30, 132, 30, 132, 87, 104, 87, 104, 87, 144, 30, 144"
              title="13.11.2022; 66,913604576"
              alt
            />
          </map>
        </div>
        <div class="legend">
          <ul>
            <li class="without">Poraba brez izvedenih ukrepov</li>
            <li class="with">Poraba z izvedenimi ukrepi</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>